module.exports = __webpack_public_path__ + "static/media/people.9935d544.svg";